import * as React from 'react';
import {TextField} from '@sail/ui';

export const DisabledReadOnly = () => (
  <div>
    <div style={{padding: '20px 0'}}>
      <TextField label="Disabled" defaultValue="Field is disabled" disabled />
    </div>
    <div style={{padding: '20px 0'}}>
      <TextField label="Readonly" defaultValue="Field is readonly" readOnly />
    </div>
  </div>
);
